import { AuthenticationRepository } from './infrastructure/AuthenticationRepository'
import { GetAccessToken } from './use-cases/GetAccessToken.usecase'
import { GetClientsPermissions } from './use-cases/GetClientsPermissions.usecase'
import { GetUserAfterLogin } from './use-cases/GetUserAfterLogin.usecase'
import { GetUserRoles } from './use-cases/GetUserRoles.usecase'
import { IsUserAuthenticated } from './use-cases/IsUserAuthenticated.usecase'
import { Logout } from './use-cases/Logout.usecase'
import { RedirectionToLoginPage } from './use-cases/RedirectionToLoginPage.usecase'
import { RetrieveAccessTokenAfterLogin } from './use-cases/RetrieveAccessTokenAfterLogin.usecase'
import { GetScopes } from './use-cases/GetScopes.usecase'

const authenticationRepository = new AuthenticationRepository()

export const getAccessToken = new GetAccessToken(authenticationRepository)
export const getClientsPermissions = new GetClientsPermissions(authenticationRepository)
export const getUserAfterLogin = new GetUserAfterLogin(authenticationRepository)
export const getUserRoles = new GetUserRoles(authenticationRepository)
export const getScopes = new GetScopes(authenticationRepository)
export const isUserAuthenticated = new IsUserAuthenticated(authenticationRepository)
export const logout = new Logout(authenticationRepository)
export const redirectionToLoginPage = new RedirectionToLoginPage(authenticationRepository)
export const handleRedirect = new RetrieveAccessTokenAfterLogin(authenticationRepository)
